export enum MonthlyArrearsMonthSelectType {
    ONE_MONTH = 'ONE_MONTH',
    ONE_THREE_MONTHS = 'ONE_THREE_MONTHS',
    THREE_SIX_MONTHS = 'THREE_SIX_MONTHS',
    SIX_TWELVE_MONTHS = 'SIX_TWELVE_MONTHS',
    TWELVE_PLUS = 'TWELVE_PLUS',
    SPECIAL = 'SPECIAL'
}
